var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.28755 9.5C9.40323 7.18852 10.7914 5.81147 12.8571 5.63115V4.35246C10.7914 4.17213 9.40323 2.81148 9.28755 0.5L7.75064 0.827869C7.83327 1.66393 8.13074 2.40164 8.62651 3.07377C9.13882 3.72951 9.71722 4.15574 10.3783 4.35246H0V5.63115H10.3783C9.71722 5.82787 9.13882 6.2541 8.62651 6.92623C8.13074 7.59836 7.83327 8.33607 7.75064 9.15574L9.28755 9.5Z","fill":"#FF757B"}));
}

Arrow.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
